import _ from 'lodash';

const PATH_RM3_FLAG = 'company.settings.enable_room_mapping_3_0';

/** Spec `hotel-deals-rm3` §2.1: strict `true`; an absent flag means the legacy deals list. */
export default function isRm3Enabled(profile) {
    return _.get(profile, PATH_RM3_FLAG, false) === true;
}
